<template>
  <div class="Login Login--accept-invitation-block d-flex flex-column justify-content-start align-items-center">
    <div class="Login-header d-flex justify-content-center p-3">
      <div
        class="Login-logo"
        @click="pushHome"
      >
        <img
          alt="Fuell logo"
          :src="require('@/assets/img/logo.svg')"
        >
      </div>
    </div>
    <template v-if="isCalling">
      <spinner />
    </template>
    <template v-else>
      <template v-if="showAcceptInvitationForm">
        <user-accept-invitation-form
          :userInvitationData="userInvitationData"
          :userTerms="userTerms"
        />
      </template>
      <template v-else>
        <div class="p-5">
          <p
            class="py-3"
            v-if="invitationTokenExpiredFlag"
            v-t="{ path : 'user_invitation_form_token_expired'}"
          ></p>
          <p
            class="py-3"
            v-if="invitationTokenNotFoundFlag"
            v-t="{path: 'user_invitation_form_token_not_found'}"
          ></p>
          <div class="d-flex justify-content-center flex-column mx-auto width-50">
            <button
              class="btn btn-primary align-self-center"
              @click="redirectToLogin"
            > {{$t('ACTION_RETURN_TO_LOGIN')}}</button>
            <span
              class="text-center text-primary clickable mt-3"
              @click="openSupport"
            > <u>{{$t('snackbar_launch_intercom_message')}}</u></span>

          </div>
        </div>
      </template>
    </template>

    <symbol
      id="logo"
      width="54px"
      height="24px"
      viewBox="0 0 54 24"
    >
      <g
        id="Symbols"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
      >
        <g
          id="Fuell-Logo-Copy"
          fill="#0089F2"
          fill-rule="nonzero"
        >
          <g id="Fuell-Logo">
            <path
              d="M1.69421635,13.129651 L0,13.129651 L0,9.17216351 L1.69421635,9.17216351 L1.69421635,8.85343968 C1.69421635,7.1889847 2.10656118,5.94951554 2.93126321,5.13499501 C3.37947084,4.69232082 3.9083479,4.37360018 4.51791027,4.17882353 C5.12747264,3.98404688 5.86252212,3.88666002 6.72308076,3.88666002 C7.51192618,3.88666002 8.16181749,3.92207342 8.67277418,3.9929013 C9.18373087,4.06372917 9.6453778,4.16111603 10.0577288,4.28506481 L10.0577288,7.84414756 C9.75294763,7.75561272 9.44817102,7.68478591 9.14338983,7.631665 C8.83860865,7.5785441 8.50693998,7.55198405 8.14837388,7.55198405 C7.18024541,7.55198405 6.69618843,8.00350496 6.69618843,8.90656032 L6.69618843,9.25184447 L10.0308365,9.25184447 L10.0308365,13.129651 L6.7768654,13.129651 L6.7768654,23.4616152 L1.69421635,23.4616152 L1.69421635,13.129651 Z M15.4093011,23.780339 C13.8495386,23.780339 12.6349141,23.3111114 11.7653913,22.3726421 C10.8958685,21.4341728 10.4611137,20.1415835 10.4611137,18.4948355 L10.4611137,9.09248255 L15.570655,9.09248255 L15.570655,16.874656 C15.570655,17.6714696 15.7588994,18.2734975 16.1353938,18.6807577 C16.5118863,19.088018 17.0138732,19.2916451 17.6413639,19.2916451 C18.2509263,19.2916451 18.7573933,19.088018 19.1607802,18.6807577 C19.564167,18.2734975 19.7658574,17.6714696 19.7658574,16.874656 L19.7658574,9.09248255 L24.8753988,9.09248255 L24.8753988,23.4616152 L19.7658574,23.4616152 L19.7658574,21.4961515 C19.2997215,22.0981885 18.7170603,22.6293895 18.0178564,23.0897707 C17.3186525,23.5501519 16.4491428,23.780339 15.4093011,23.780339 Z M35.8474666,15.0951147 C35.7578251,14.2983011 35.4889045,13.6652865 35.0406969,13.1960518 C34.5924893,12.7268172 34.0187921,12.4922034 33.3195882,12.4922034 C32.6383126,12.4922034 32.0825435,12.7268172 31.6522642,13.1960518 C31.2219849,13.6652865 30.9351363,14.2983011 30.7917099,15.0951147 L35.8474666,15.0951147 Z M33.7498654,23.8068993 C32.6024539,23.8068993 31.5536638,23.6254056 30.6034636,23.2624128 C29.6532634,22.8994199 28.8330558,22.3947789 28.1428161,21.7484746 C27.4525763,21.1021702 26.9147352,20.3186487 26.5292767,19.3978863 C26.1438181,18.477124 25.9510917,17.4589886 25.9510917,16.3434497 L25.9510917,16.290329 C25.9510917,15.2456179 26.1303721,14.2673226 26.4889382,13.3554138 C26.8475025,12.4435049 27.3539713,11.6467033 28.0083544,10.964985 C28.6627376,10.2832668 29.4381251,9.74763904 30.3345404,9.35808574 C31.2309556,8.96853245 32.2169976,8.77375872 33.2926959,8.77375872 C34.5476773,8.77375872 35.6368055,8.98623915 36.5601132,9.41120638 C37.4834209,9.83617361 38.2453624,10.4072148 38.8459606,11.124347 C39.4465588,11.8414792 39.8947597,12.6736942 40.1905768,13.6210169 C40.4863938,14.5683397 40.6343001,15.5731951 40.6343001,16.6356132 L40.6343001,17.1402592 C40.6343001,17.3173289 40.6253361,17.4943959 40.6074078,17.6714656 L30.8723868,17.6714656 C31.0695982,18.4682792 31.4416049,19.0614537 31.9884182,19.451007 C32.5352315,19.8405583 33.2120149,20.035334 34.0187886,20.035334 C34.628351,20.035334 35.1886021,19.9202404 35.6995588,19.6900499 C36.2105155,19.4598593 36.7259466,19.0880185 37.2458674,18.5745165 L40.0695613,20.8852642 C39.3703574,21.7706126 38.5053297,22.4788807 37.4744521,23.0100897 C36.4435746,23.5412988 35.2020581,23.8068993 33.7498654,23.8068993 Z M41.8444546,5.31206381 L46.953996,5.31206381 L46.953996,23.4616152 L41.8444546,23.4616152 L41.8444546,5.31206381 Z M48.8364586,0 L53.946,0 L53.946,23.4616152 L48.8364586,23.4616152 L48.8364586,0 Z"
              id="logo"
            ></path>
          </g>
        </g>
      </g>
    </symbol>
  </div>
</template>

<script>
import * as Sentry from '@sentry/vue'
import UserAcceptInvitationForm from '../../_components/signup/UserAcceptInvitationForm'
import Spinner from '@/components/Commons/Spinner'
import usersApi from '@/modules/users/_api'

import { segmentTrack, segmentIdentify } from '@/analytics/segment'
export default {
  name: 'UserAcceptInvitation',
  data () {
    return {
      showReturnToLoginFlag: false,
      userInvitationData: {},
      invitationTokenExpiredFlag: false,
      invitationTokenNotFoundFlag: false,
      isCalling: false,
      userTerms: {}
    }
  },
  methods: {
    pushHome () {
      Sentry.setUser(null)
      this.$router.push('/signin')
    },
    async openSupport () {
      let errorMessage = ''
      if (this.invitationTokenExpiredFlag) {
        errorMessage = this.$t('user_invitation_form_token_expired')
      }
      if (this.invitationTokenNotFoundFlag) {
        errorMessage = this.$t('user_invitation_form_token_not_found')
      }
      const defaultMessage = this.$route && this.$route.path ? this.$t('intercom_predefined_error_message_with_route', { errorMessage: errorMessage, routerUrl: this.$route.path }) : this.$t('intercom_predefined_error_message', { errorMessage: errorMessage })
      if (window.HubSpotConversations?.widget?.open) {
        window.HubSpotConversations.widget.open(defaultMessage)
      }
    },
    async fetchUserTokenInformation () {
      try {
        this.isCalling = true
        const invitationToken = this.$route.params.token
        if (!invitationToken) return
        const response = await usersApi.getUserByInvitation(invitationToken)
        this.userInvitationData = response.data
        const userTraits = {
          user_id: this.userInvitationData.id,
          username: this.userInvitationData.firstName,
          email: this.userInvitationData.email,
          signup_source: 'web',
          user_role: this.userInvitationData.roles.join(','),
          onboarding_status: 'ONBOARDING_STARTED'
        }
        this.fetchUserTerms()
        segmentIdentify(this.userInvitationData.id, userTraits)
        segmentTrack('User onboarding information provided', {
          invitation_id: invitationToken,
          result: 'found'
        })
      } catch (error) {
        if (error.response.status === 403) {
          this.invitationTokenExpiredFlag = true
          this.invitationTokenNotFoundFlag = false
        }
        if (error.response.status !== 403) {
          this.invitationTokenExpiredFlag = false
          this.invitationTokenNotFoundFlag = true
        }
        segmentTrack('User onboarding information provided', {
          invitation_id: this.$route.params.token,
          result: 'not_found'
        })
      } finally {
        this.isCalling = false
      }
    },
    async fetchUserTerms () {
      try {
        const invitationToken = this.$route.params.token
        if (!invitationToken) return
        const response = await usersApi.getUserTerms(invitationToken)
        this.userTerms = response.data
      } catch (error) { }
    },
    redirectToLogin () {
      this.$router.push({ name: 'login' })
    }

  },
  computed: {
    phonePrefixList () {
      return this.$store.getters['ConfigStore/publicConfig'].countries || []
    },
    showAcceptInvitationForm () {
      return !!((this.phonePrefixList.length > 0 && this.userInvitationData && this.userInvitationData.email))
    }
  },
  components: {
    UserAcceptInvitationForm, Spinner
  },
  async created () {
    await this.fetchUserTokenInformation()
    try {
      this.isCalling = true
      await this.$store.dispatch('ConfigStore/fetchPublicConfig')
    } catch (e) {
      console.error(e)
    } finally {
      this.isCalling = false
    }
  }

}
</script>

<style scoped>
.Login-logo {
  margin-bottom: 12px;
}
</style>
